var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('b-tabs',[_c('br'),_c('b-tab',{attrs:{"title":"AWS","active":""}},[_c('AwsPerseusForm')],1),_c('b-tab',{attrs:{"title":"Azure"}},[_c('AzurePerseusForm')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }